import React from "react";
import { List, Space } from "antd";
import { File } from "../../../redux/interfaces/folder.types.ts";
import { FileComponent } from "./FileComponent.tsx";

interface Props {
  fileList: File[];
  download?: boolean;
  disableDelete?: boolean;
}

export const Files: React.FC<Props> = ({
  fileList,
  download = true,
  disableDelete = false,
}) => {
  return (
    <Space direction="vertical" className="w-full">
      <List
        itemLayout="horizontal"
        dataSource={fileList}
        renderItem={(file) => (
          <FileComponent
            file={file}
            key={file.id}
            download={download}
            disableDelete={disableDelete}
          />
        )}
      />
    </Space>
  );
};
